/**
 * @generated SignedSource<<e8fc5ac6c47dc207e5052332f6dac67e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
export type PianofunclubLessonBlockModelTypeChoices = "ARCHIVED" | "BREAK" | "LESSON" | "%future added value";
export type PianofunclubLessonModelStatusChoices = "BLANK" | "BREAK" | "LEFT_SCHOOL" | "MISSED" | "NO_LESSON" | "OTHER_TEACHER" | "PRESENT" | "PRESENT_DOUBLE" | "PUPIL_ABSENT" | "STOPPED_LESSONS" | "TEACHER_ABSENT" | "%future added value";
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LoadLessonBlocks_query_lessonBlocks$data = {
  readonly lessonBlocks: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly block: number | null | undefined;
        readonly enrolmentOffers: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly archived: boolean;
              readonly enrolment: {
                readonly id: string;
                readonly parentName: string | null | undefined;
                readonly pupilFirstName: string | null | undefined;
                readonly pupilLastName: string | null | undefined;
                readonly status: PianofunclubEnrolmentModelStatusChoices;
              };
              readonly id: string;
              readonly offerAccepted: boolean;
            } | null | undefined;
          } | null | undefined>;
        };
        readonly id: string;
        readonly instrument: {
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly keepFree: boolean;
        readonly lessonDay: number | null | undefined;
        readonly lessonStage: {
          readonly costPerLesson: number | null | undefined;
          readonly id: string;
          readonly lessonDuration: number | null | undefined;
          readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
          readonly stage: number | null | undefined;
        } | null | undefined;
        readonly lessonTime: string | null | undefined;
        readonly lessons: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly blacklistedDate: {
                readonly id: string;
                readonly reason: string | null | undefined;
              } | null | undefined;
              readonly homework: {
                readonly id: string;
              } | null | undefined;
              readonly id: string;
              readonly lessonDuration: number | null | undefined;
              readonly rearrangedTimestamp: string | null | undefined;
              readonly replacementLessonColumnIndex: number | null | undefined;
              readonly scheduledTimestamp: string | null | undefined;
              readonly staffRegisterNoteForTeacher: string | null | undefined;
              readonly status: PianofunclubLessonModelStatusChoices;
              readonly teacherRegisterNoteForStaff: string | null | undefined;
              readonly weekWasRearranged: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined>;
        };
        readonly pupil: {
          readonly id: string;
          readonly schoolYear: number | null | undefined;
          readonly staffNoteForTeacher: string | null | undefined;
          readonly teacherNoteForStaff: string | null | undefined;
          readonly user: {
            readonly firstName: string;
            readonly lastName: string;
          };
        } | null | undefined;
        readonly school: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly staffNoteForTeacher: string | null | undefined;
        readonly teacher: {
          readonly id: string;
          readonly user: {
            readonly firstName: string;
            readonly lastName: string;
          };
        } | null | undefined;
        readonly teacherNoteForStaff: string | null | undefined;
        readonly type: PianofunclubLessonBlockModelTypeChoices;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "LoadLessonBlocks_query_lessonBlocks";
};
export type LoadLessonBlocks_query_lessonBlocks$key = {
  readonly " $data"?: LoadLessonBlocks_query_lessonBlocks$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoadLessonBlocks_query_lessonBlocks">;
};

import LoadLessonBlocksPaginationQuery_graphql from './LoadLessonBlocksPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "lessonBlocks"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffNoteForTeacher",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teacherNoteForStaff",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonDuration",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "block"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "blockType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dayIndex"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "schoolId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startingYear"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": LoadLessonBlocksPaginationQuery_graphql
    }
  },
  "name": "LoadLessonBlocks_query_lessonBlocks",
  "selections": [
    {
      "alias": "lessonBlocks",
      "args": [
        {
          "kind": "Variable",
          "name": "block",
          "variableName": "block"
        },
        {
          "kind": "Variable",
          "name": "blockType",
          "variableName": "blockType"
        },
        {
          "kind": "Variable",
          "name": "dayIndex",
          "variableName": "dayIndex"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "profileId",
          "variableName": "profileId"
        },
        {
          "kind": "Variable",
          "name": "schoolId",
          "variableName": "schoolId"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "startingYear",
          "variableName": "startingYear"
        }
      ],
      "concreteType": "LessonBlockNodeConnection",
      "kind": "LinkedField",
      "name": "__LoadLessonBlocks_query_lessonBlocks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonBlockNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonBlockNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "block",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "keepFree",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonTime",
                  "storageKey": null
                },
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SchoolNode",
                  "kind": "LinkedField",
                  "name": "school",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfileNode",
                  "kind": "LinkedField",
                  "name": "pupil",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "schoolYear",
                      "storageKey": null
                    },
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfileNode",
                  "kind": "LinkedField",
                  "name": "teacher",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "InstrumentNode",
                  "kind": "LinkedField",
                  "name": "instrument",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LessonStageNode",
                  "kind": "LinkedField",
                  "name": "lessonStage",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lessonType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "costPerLesson",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LessonNodeConnection",
                  "kind": "LinkedField",
                  "name": "lessons",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LessonNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LessonNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "scheduledTimestamp",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "rearrangedTimestamp",
                              "storageKey": null
                            },
                            (v7/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "teacherRegisterNoteForStaff",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "staffRegisterNoteForTeacher",
                              "storageKey": null
                            },
                            (v6/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "weekWasRearranged",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "replacementLessonColumnIndex",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "BlacklistedDateNode",
                              "kind": "LinkedField",
                              "name": "blacklistedDate",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "reason",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "HomeworkNode",
                              "kind": "LinkedField",
                              "name": "homework",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "archived",
                      "value": false
                    },
                    {
                      "kind": "Literal",
                      "name": "offerAccepted",
                      "value": false
                    }
                  ],
                  "concreteType": "EnrolmentOfferNodeConnection",
                  "kind": "LinkedField",
                  "name": "enrolmentOffers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EnrolmentOfferNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EnrolmentOfferNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "archived",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "offerAccepted",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "EnrolmentNode",
                              "kind": "LinkedField",
                              "name": "enrolment",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v7/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "pupilFirstName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "pupilLastName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "parentName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "enrolmentOffers(archived:false,offerAccepted:false)"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "94b087210b723c7f575a8455d8ad2d11";

export default node;
